import * as React from "react";
import { Icon } from "../frame";
import * as cls from "./Dialog.module.scss";
export { Dialog };
/**
 * Модальный диалог.
 * @param {CountdownModel} props - Атрибуты элемента.
 * @param {string} props.title - Заголовок.
 * @param {boolean} props.open - Показать диалог.
 * @param {EventListener} props.onClose - Действие закрытия.
 * @param {JSX.Element} props.children - Содержимое.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Dialog({ title, open, onClose, children }) {
  if (!open) return null;
  return (
    <div className={cls.modal_container} onClick={onClose}>
      <div className={cls.modal_dialog} onClick={ignoreClick}>
        <div className={cls.dialog_header}>
          <h2 className={cls.dialog_title}>
            {title}
          </h2>
          <a
            className={cls.dialog_close}
            href="#close"
            title="Закрыть"
            onClick={onClose}>
            <Icon name="close" />
          </a>
        </div>
        <div className={cls.dialog_body}>
          {children}
        </div>
      </div>
    </div>
  );
  function ignoreClick(event) {
    event.stopPropagation();
  }
}
